import { produce } from 'immer'

// Action Types
export const SET_OUTBOUND_CAMPAIGNS = 'outbound/setCampaigns'
export const SET_OUTBOUND_CAMPAIGN = 'outbound/setCampaign'
export const SET_OUTBOUND_CAMPAIGN_STATS = 'outbound/setCampaignStats'
export const SET_OUTBOUND_CAMPAIGN_CALL_LOG = 'outbound/setCampaignCallLog'
export const SET_OUTBOUND_CAMPAIGN_OPT_OUTS = 'outbound/setCampaignOptOuts'
export const SET_OUTBOUND_CAMPAIGNS_LOADING = 'outbound/campaigns/setLoading'
export const SET_VOICE_AGENTS = 'outbound/setVoiceAgents'

// Action Creators
export const setCampaigns = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGNS,
  payload,
})

export const setCampaign = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGN,
  payload,
})

export const setCampaignStats = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGN_STATS,
  payload,
})

export const setCampaignCallLog = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGN_CALL_LOG,
  payload,
})

export const setCampaignOptOuts = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGN_OPT_OUTS,
  payload,
})

export const setLoading = (payload) => ({
  type: SET_OUTBOUND_CAMPAIGNS_LOADING,
  payload,
})

export const setVoiceAgents = (payload) => ({
  type: SET_VOICE_AGENTS,
  payload,
})

// State
export const initialState = {
  data: {
    campaigns: [],
    campaign: null,
    campaignStats: null,
    campaignCallLog: [],
    campaignCallLogTotal: 0,
    campaignOptOuts: [],
    campaignOptOutsTotal: 0,
    voiceAgents: [],
  },
  loading: {
    campaigns: false,
    campaign: false,
    campaignStats: false,
    campaignCallLog: false,
    campaignOptOuts: false,
    optOutsExport: false,
    optOutsUpload: false,
  },
}

// Reducer
export default function outboundCampaignsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_OUTBOUND_CAMPAIGNS_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_OUTBOUND_CAMPAIGNS:
        newState.data.campaigns = payload
        break
      case SET_OUTBOUND_CAMPAIGN:
        newState.data.campaign = payload
        break
      case SET_OUTBOUND_CAMPAIGN_STATS:
        newState.data.campaignStats = payload
        break
      case SET_OUTBOUND_CAMPAIGN_CALL_LOG:
        newState.data.campaignCallLog = payload.calls || []
        newState.data.campaignCallLogTotal = payload.total || 0
        break
      case SET_OUTBOUND_CAMPAIGN_OPT_OUTS:
        newState.data.campaignOptOuts = payload.opt_outs || []
        newState.data.campaignOptOutsTotal = payload.total || 0
        break
      case SET_VOICE_AGENTS:
        newState.data.voiceAgents = payload
        break
      default:
        break
    }
  })
}
